import pkg from "../package.json";
import {updateTranslations} from "./i18n"
import {logout} from "./request";
import Vue from "vue";

export default Vue.mixin(
{
  data () {
    return {
      publicPath: process.env.BASE_URL,
      version: pkg.version
    }
  },
  computed: {
    user:
    {
      get() {
        return this.$store.state.user;
      },
      set(value) {
        this.$store.commit("updateState", {name: "user", value});
      }
    },
    loading:
    {
      get() {
        return this.$store.state.loading;
      },
      set(value) {
        this.$store.commit("updateState", {name: "loading", value});
      }
    },
    lastSync:
    {
      get() {
        return this.$store.state.lastSync;
      },
      set(value) {
        this.$store.commit("updateState", {name: "lastSync", value});
      }
    },
    countries:
    {
      get() {
        return this.$store.state.countries;
      },
      set(value) {
        this.$store.commit("updateState", {name: "countries", value});
      }
    },
    waterSystems:
    {
      get() {
        return this.$store.state.waterSystems;
      },
      set(value) {
        this.$store.commit("updateState", {name: "waterSystems", value});
      }
    },
    allAssets:
    {
      get() {
        return this.$store.state.allAssets;
      },
      set(value) {
        this.$store.commit("updateState", {name: "allAssets", value});
      }
    },
    cultureCode:
    {
      get() {
        return this.$store.state.cultureCode;
      },
      set(value) {
        this.$store.commit("setCultueCode", value);
      }
    },
    notification:
    {
      get() {
        return this.$store.state.notification;
      },
      set(value) {
        this.$store.commit("updateState", {name: "notification", value});
      }
    },
    hasHousehold: function()
    {
      if(this.user)
      {
        return !!this.user.householdID
      }

      return false;
    }
  },
  methods: {
    getWaterSystems: async function()
    {
      let response;

      if(!this.user || this.user.role == "Super User")
      {
        response = await this.$http.get(`/WaterSystem`);
      }

      else if(this.user.organisationID != null)
      {
        response = await this.$http.get(`/WaterSystem?organisationID=${this.user.organisationID}`);
      }

      else
      {
        response = await this.$http.get(`/WaterSystem?countryID=${this.user.countryID}`);
      }

      this.waterSystems = response.data;
    },
    updateUser: async function()
    {
      try
      {
          const response = await this.$http.get(`/User`);
          const user = response.data;
          this.$store.commit("updateState", {name: "user", value: user});
      }

      catch(error)
      {
          return;
      }
    },
    isActive: function(name) {
      if(this.$route.name == name) {
        return true;
      }

      else if(name.startsWith("/") && this.$route.path.startsWith(name))
      {
        return true;
      }
    },
    showTabs: function()
    {
      const content = document.querySelector("#content");
      const tabs = document.querySelector("#tabs");

      if(content && tabs)
      {
        tabs.classList.remove("is-hidden-mobile");
        content.classList.remove("notabs");
      }
    },
    hideTabs: function()
    {
      const content = document.querySelector("#content");
      const tabs = document.querySelector("#tabs");

      if(content && tabs)
      {
        tabs.classList.add("is-hidden-mobile");

        if(window.innerWidth < 768)
        {
          content.classList.add("notabs");
        }
      }
    },
    minimumTransfer: function(currency)
    {
      var amount = parseFloat(currency.exchangeRate.toFixed(currency.roundToDP));
      var value = 1;
      var zeroes = "";

      for(var i=0; i < currency.roundToDP; i++)
      {
          if(i == 0)
          {
              zeroes += "0.";
              continue;
          }

          zeroes += "0";
      }

      value = zeroes + value;

      while(amount < currency.exchangeRate)
      {
          amount += parseFloat(value);
      }

      return amount;
    },
    formatCurrency: function(amount, currency, raw)
    {
        amount = amount.toFixed(currency.roundToDP);

        if(raw)
        {
          return amount;
        }

        else
        {
          return currency.isPrefix ? currency.symbol + amount : amount + currency.symbol;
        }
    },
    showCurrency: function(credits, currency, raw)
    {
        var amount = credits * currency.exchangeRate;
        return this.formatCurrency(amount, currency, raw);
    },
    logout,
    hasPermission: function(name, value)
    {
      if(this.user)
      {
        return ["Super User", "Reseller", "Registrar"].indexOf(this.user.role) != -1;
      }

      return false;
    },
    updateTranslations
  }
});